<template>
  <el-select filterable v-model="displayValue" placeholder="Select" :clearable="true" :disabled="disabled" v-loading="isLoading">
    <el-option v-for="classification in classificationList" :value="classification.id" :label="classification.description" :key="classification.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'asset-classification',
  props: {
    value: {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        return this.value
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  data () {
    return {
      classificationList: Array,
      isLoading: true
    }
  },
  methods: {
    fetchClassificationList () {
      this.isLoading = true
      var call = '/getPEAFinancialAssetClassificationList'
      this.$axios.get(call).then(response => {
        this.classificationList = response.data
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        if (this.$route.name === 'PEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Financial Classifications', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'Custom Grouping Reports') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Financial Classifications', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'advancedSearch') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Financial Classifications', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'ClonedPEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Financial Classifications', reject.body, 'error', 30000, '')
        } else if (this.$route.name === 'Print PEA') {
          helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting Financial Classifications', reject.body, 'error', 30000, '')
        }
      })
    }
  },
  created () {
    this.fetchClassificationList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
